import { Component, OnInit, TemplateRef } from '@angular/core';
import { ModalWidth, IButtonProps } from '@amobee/component-library';

export interface ModalFooterButton extends IButtonProps {
  // if it is undefined, default to close modal
  onConfirm?(): void;
}

export interface ModalProps {
  // Modal
  width?: ModalWidth;
  closeButton?: boolean;

  // Modal Header
  headerContent?: string;

  // Modal Body
  //titleIcon?: boolean; currently not implement in the angular wrapper
  //scroll?: boolean; currently not implement in the angular wrapper
  bodyContent: {
    message: string;
    subMessage?: string;
  } | TemplateRef<any>;

  // Modal Footer
  // if it is undefined, default to OK primary button
  footerContent?: ModalFooterButton[];
}

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  public modalProps: ModalProps = {
    headerContent: 'Info',
    bodyContent: { message: 'Initial Body' },
    footerContent: []
  };
  public open: boolean = false;

  constructor() { }

  ngOnInit() { }

  openModal() {
    this.open = true;
  }

  closeModal() {
    this.open = false;
  }

}
